export const bookingListPath = (projectId: string) => {
  return `/projects/${projectId}/bookings`;
};

export const deleteBookingPath = (bookingId: string) => {
  return `/common-area/booking/${bookingId}`;
};
